'use client';

import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { useEffect, useState } from 'react';
import { LocalStorage } from 'utils/LocalStorage';

export const useContentDetailEpisodeOrderType = ({
  initialOrderType,
  defaultValue = EpisodeOrderType.FirstOrder,
}: {
  initialOrderType?: EpisodeOrderType;
  defaultValue?: EpisodeOrderType;
}) => {
  const key = LocalStorageKey.EpisodeOrderType;
  const [orderType, setOrderType] = useState(initialOrderType || defaultValue);

  useEffect(() => {
    const savedOrderType = LocalStorage.getItem(key as LocalStorageKey) as EpisodeOrderType;
    if (savedOrderType) {
      setOrderType(savedOrderType);
    }
  }, [key]);

  useEffect(() => {
    if (initialOrderType) {
      LocalStorage.setItem(key as LocalStorageKey, initialOrderType);
      setOrderType(initialOrderType);
    }
  }, [initialOrderType, key]);

  return { orderType, setOrderType };
};
